import React from 'react';
import { useStaticQuery, graphql, navigate } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

const NavLang = ({ lang: currentLang }) => {
  const { site } = useStaticQuery(graphql`
    query NAV_LANG_QUERY {
      site {
        siteMetadata {
          langs
        }
      }
    }
  `);

  const getLink = lang => {
    if (typeof window !== 'undefined') {
      return `${window.location.pathname.replace(currentLang, lang)}`;
    }
    return `/`;
  };

  return (
    <nav className="nav-lang">
      <ul className="d-flex">
        {site.siteMetadata.langs.map((lang, index) => (
          <li
            className={`${
              index === site.siteMetadata.langs.length - 1 ? '' : 'mr-5'
            }`}
            key={lang}
          >
            <AniLink
              cover
              direction="up"
              bg="#092431"
              replace
              to={getLink(lang)}
              className={`${lang === currentLang ? 'active' : ''}`}
            >
              {lang}
            </AniLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavLang;
